module.exports = __webpack_public_path__ + "media/customizations/gareybldg/logo-2b6f216040d4422eeece99111ca4651d.png";